import React from "react";
import PaiyaGiftsList from "./PaiyaGiftsList";
//import addupdate page
import { IIdValuePairResponse, IPaiyaGiftsPageProps, IPaiyaGiftsPageState } from "interfaces/Index";
import HeadingText from "components/common/HeadingText/HeadingText";
import AddUpdatePaiyaGiftPage from "./AddUpdatePaiyaGiftPage";

export default class PaiyaGiftPage extends React.Component<IPaiyaGiftsPageProps, IPaiyaGiftsPageState>{

    constructor(props: IPaiyaGiftsPageProps) {
        super(props);
        this.state = {
            showAddUpdatePage: false,
            //isPaiyaGiftAddUpdate: false,
            searchText: "",
            currentListPosition: 0,
            selectedType: {
                id: "",
                name: "",
            }
        }
    }

    toggleAddUpdatePaiyaGiftPage = (
        selectedType: IIdValuePairResponse = { id: "", name: "" },
        searchText: string = "",
        currentScroll: number = 0
    ) => {
        const { showAddUpdatePage } = this.state;
        this.setState({
            showAddUpdatePage: !showAddUpdatePage,
            searchText: searchText,
            currentListPosition: currentScroll,
            selectedType: selectedType
        });
    };

    navigateBackToListingPage = (isAddUpdate: boolean) => {
        const { showAddUpdatePage, searchText, currentListPosition } = this.state;
        this.setState({
            showAddUpdatePage: !showAddUpdatePage,
            searchText: isAddUpdate ? "" : searchText,
            currentListPosition: isAddUpdate ? 0 : currentListPosition,
        });
    };

    renderAddUpdatePaiyaGiftPage = () => {
        const {
            isLoading,
            createPaiyaGift,
            isError,
            error,
            uploadImageAndCreatePaiyaGiftAction,
            isPaiyaGiftCreated,
            clearPaiyaGiftDetails
        } = this.props;
        return (
            <AddUpdatePaiyaGiftPage
                isLoading={isLoading}
                isError={isError}
                error={error}
                isPaiyaGiftCreated={isPaiyaGiftCreated}
                defaultPaiyaGift={{
                    id: "",
                    type: {
                        id: "COINS",
                        label: "COINS",
                        type: "number",
                        value: "VALUE"
                    },
                    title: "",
                    value: "",
                    image: {},
                }}
                createPaiyaGift={createPaiyaGift}
                backButtonHandler={this.navigateBackToListingPage}
                uploadImageAndCreatePaiyaGiftAction={uploadImageAndCreatePaiyaGiftAction}
                clearPaiyaGiftDetails={clearPaiyaGiftDetails}
            />
        )
    }

    renderPaiyaGiftsListing = () => {
        const {
            paiyaGifts,
            isLoading,
            isError,
            error,
            isPaiyaGiftCreated,
            fetchPaiyaGifts,
        } = this.props;

        const {
            searchText,
            selectedType,
            currentListPosition
        } = this.state;

        return (
            <>
                <section className="main-heading-margin">
                    <HeadingText text="Paiya Gifts" isMainHeading />
                </section>
                <PaiyaGiftsList
                    fetchPaiyaGifts={fetchPaiyaGifts}
                    addUpdatePageHandler={this.toggleAddUpdatePaiyaGiftPage}
                    paiyaGifts={paiyaGifts}
                    isLoading={isLoading}
                    isError={isError}
                    error={error}
                    isPaiyaGiftCreated={isPaiyaGiftCreated}
                    currentListPosition={currentListPosition}
                    retainedSearchText={searchText}
                    selectedType={selectedType}

                />
            </>
        )
    }
    render(){
        const { showAddUpdatePage } = this.state;
    return (
        <div>
            {showAddUpdatePage
                ? this.renderAddUpdatePaiyaGiftPage()
                : this.renderPaiyaGiftsListing()}
        </div>
    );
    }

    
}